import $ from 'jquery';
import { keyboardEvents, customEvents } from '../utils/Utils';

const $fadeInButtons = $('.js_fade_in');
const $fadeOutButtons = $('.js_fade_out');

const show = ($element) => {
    $element.addClass('active');
    $element.fadeIn(700, 'swing', () => {
        document.documentElement.dispatchEvent(customEvents.modalopened);
    });

    $(document).on('keydown', (e) => {
        if (keyboardEvents.isExit(e.keyCode)) {
            $element.find('.btn--close').trigger('click');
        }
    });
};

const close = ($element) => {
    $element.removeClass('active');
    $element.fadeOut(700, 'swing', () => {
        document.documentElement.dispatchEvent(customEvents.modalclosed);
    });
    $(document).off('keydown');
};

function fadeInButtonClickHandler(e) {
    e.preventDefault();

    const activeModals = $('.modal.active');
    if (activeModals.length) {
        close($(`[data-name="${activeModals[0].dataset.name}"]`));
    }

    if (!this.dataset.preventHistory) {
        history.pushState(null, '', `#${this.dataset.target}`);
    }

    const $target = $(`[data-name="${this.dataset.target}"]`);
    show($target);
}

function fadeOutButtonClickHandler(e) {
    e.preventDefault();

    if (!this.dataset.preventHistory) {
        history.back();
    }

    const $target = $(`[data-name="${this.dataset.target}"]`);

    close($target);
}

const onHashChanged = (e) => {
    const newHash = e.newURL.split('#');
    const oldHash = e.oldURL.split('#');

    if (oldHash[1]) {
        close($(`[data-name="${oldHash[1]}"]`));
    }

    if (newHash[1]) {
        show($(`[data-name="${newHash[1]}"]`));
    }
};

const init = () => {
    $fadeInButtons.on('click', fadeInButtonClickHandler);

    $fadeOutButtons.on('click', fadeOutButtonClickHandler);

    window.addEventListener('hashchange', onHashChanged);

    $fadeInButtons.filter(`[data-target="${location.hash.slice(1)}"]`).trigger('click');
};

export default init();
